module.exports = __webpack_public_path__ + "img/sample-score.dad7b4f1.png";